import { inject } from '@angular/core'
import { CanDeactivateFn } from '@angular/router'

import { Services } from '../shared/services'
import { MeetingHubService } from '../shared/services/meeting-hub.service'
import { MeetingsComponent } from './meetings/meetings.component'

function isAuthRedirect(url: string): boolean {
    return url.startsWith('/signin') || url.startsWith('/signup') || url.startsWith('/mfa-setup') || url.startsWith('/mfa-verify')
}

export const leaveActiveMeetingGuard: CanDeactivateFn<MeetingsComponent> = (
    component,
    _currentRoute,
    _currentState,
    nextState,
) => {
    const hub = inject(MeetingHubService)
    const services = inject(Services)

    const inMeeting = hub.activeMeetingId() ?? component.activeMeeting()?.id ?? null
    if (!inMeeting) {
        return true
    }

    const targetUrl = nextState.url
    if (isAuthRedirect(targetUrl)) {
        return true
    }

    return services.modals
        .leaveMeetingPrompt(targetUrl, hub.isLead())
        .then(result => result === 'leave')
        .catch(() => false)
}
